module.exports = __webpack_public_path__ + "img/Gaz.fe2f7217.jpg";